import Proxy from './Proxy';

class GroupProxy extends Proxy {
  /**
   * The constructor for the CareplanProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/Groups', parameters);
  }

  /**
   * Method used to create user profile.
   *
   * @param {id} id.
   *
   * @returns {Promise} The result in a promise.
   */
  upsert(data) {
    return this.submit('post', `${this.endpoint}/upsert`, data);
  }

  /**
   * Method used to view user profile.
   *
   * @param {id} id.
   *
   * @returns {Promise} The result in a promise.
   */
  viewAll(data) {
    return this.submit('get', `${this.endpoint}`, data);
  }

  getGroupInfo(groupId) {
    return this.submit('get', `${this.endpoint}/${groupId}`);
  }
}

export default GroupProxy;
